import { type Enum } from '../../utils/enums'

export const BILL_BY_TYPES = {
  QTY: 'qty',
  COST: 'cost',
}

export type BillByType = Enum<typeof BILL_BY_TYPES>
